const InlineSpinner = function(props) {
  return (<span className="inline-spinner">
            <span className="css-spinloader"></span>
            {props.text !== false ? <span className="text">{props.text || 'Laden...'}</span> : null}
          </span>);
}

export default InlineSpinner;
